/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerQuickInsightsThresholdSetting } from '../../models/customer-quick-insights-threshold-setting';

export interface GetSettingsByTitleRoleId$Params {
  customerId: number;
}

export function getSettingsByTitleRoleId(http: HttpClient, rootUrl: string, params: GetSettingsByTitleRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerQuickInsightsThresholdSetting>> {
  const rb = new RequestBuilder(rootUrl, getSettingsByTitleRoleId.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerQuickInsightsThresholdSetting>;
    })
  );
}

getSettingsByTitleRoleId.PATH = '/api/customer/quickInsight/threshold/setting/customerId/{customerId}';
